import { Book, FileText, Image, Plus, Users, Video } from 'lucide-react';

type SearchOptionProps = {
  icon: React.ReactNode;
  label: string;
  theme?: "dark" | "light";
};

const SearchOption = ({ icon, label, theme }: SearchOptionProps) => {
  const buttonClass = theme === "dark" 
    ? "flex items-center gap-1 px-[10px] py-1 rounded-full text-primary-text text-xs font-medium leading-4"
    : "flex items-center gap-1 px-[10px] py-1 rounded-full text-primary-text text-xs border-1 border-primary-border font-medium leading-4";
    
  const buttonStyle = theme === "dark" 
    ? { backgroundColor: "rgba(255, 255, 255, 0.06)" }
    : {};
    
  return (
    <button className={buttonClass} style={buttonStyle}>
      {icon}
      <span>{label}</span>
    </button>
  );
};

const optionClass = "w-4 h-4 text-highlight"

const options = [
  {
    icon: <Book className={optionClass} />,
    label: 'Cursos',
    enabled: true,
  },
  {
    icon: <Video className={optionClass} />,
    label: 'Vídeos',
    enabled: false,
  },
  {
    icon: <Users className={optionClass} />,
    label: 'Professores',
    enabled: false,
  },
  {
    icon: <FileText className={optionClass} />,
    label: 'Artigos',
    enabled: false,
  },
  {
    icon: <Image className={optionClass} />,
    label: 'Imagens',
    enabled: false,
  },
  {
    icon: <Plus className={optionClass} />,
    label: 'Mais',
    enabled: false,
  },
];

export function SearchSelector({ theme = "dark" }: { theme?: "dark" | "light" }) {
  return (
    <div className="px-4 py-4">
      <p className="text-primary-text text-sm font-medium leading-5 overflow-hidden truncate mb-4">Estou buscando por...</p>
      <div className="flex flex-wrap gap-2">
        {options
          .filter((option) => option.enabled)
          .map((option) => (
            <SearchOption key={option.label} {...option} theme={theme} />
          ))}
      </div>
    </div>
  );
}
